export enum RegistrationStatus {
  RESERVED=0,
  CONFIRMED=1
}
